import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "../utils/apiResponse";

export const getBlogPosts = async (page = 1, pageSize = 100) => {
  const response = await axiosClient.get("/api/admin/blog", {
    params: { page, pageSize },
  });
  return unwrapApiResponse(response);
};

export const getBlogPostById = async (id) => {
  const response = await axiosClient.get(`/api/admin/blog/${id}`);
  return unwrapApiResponse(response);
};

export const createBlogPost = async (payload) => {
  const response = await axiosClient.post("/api/admin/blog", payload);
  return unwrapApiResponse(response);
};

export const updateBlogPost = async (id, payload) => {
  const response = await axiosClient.put(`/api/admin/blog/${id}`, payload);
  return unwrapApiResponse(response);
};

export const deleteBlogPost = async (id) => {
  const response = await axiosClient.delete(`/api/admin/blog/${id}`);
  return unwrapApiResponse(response);
};

export const uploadBlogCover = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post("/api/admin/blog/upload-cover", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return unwrapApiResponse(response);
};
